import React from 'react';
import { Row, Col, Layout, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Footer } from 'antd/lib/layout/layout';
import { ElfsightWidget } from 'react-elfsight-widget';

import Contact from 'src/assets/images/Contact.jpg';
import Email from 'src/assets/images/Email.jpg';
import Address from 'src/assets/images/Address.jpg';
import { CONTACT_INFO } from 'src/constants/app';
import PluginQrCode from './pluginQrCode';
import usePlugin from 'src/queries/usePlugin';
import useSiteInfo from 'src/queries/useSiteInfo';

type Props = {
  hasContact?: boolean;
  hasMenu?: boolean;
};

const AppFooter: React.FC<Props> = ({ hasMenu = true, hasContact = true }) => {
  const { t } = useTranslation();
  const { queryPlugin } = usePlugin();
  const { queryCompanyInfo } = useSiteInfo(hasContact);
  const companyInfo = queryCompanyInfo?.data?.data?.item;
  const currentYear = new Date().getFullYear();

  return (
    <Footer className="footer">
      {hasContact && (
        <Layout className="layout-container custom_layout_container">
          <div className="container-lg custom-container-lg">
            <div className="contact-title">
              <div className="contact-title-left"></div>
              <p className="contact-title-text">{t('footer.contact.title')}</p>
              <div className="contact-title-right"></div>
            </div>
            <Row className="footer-contact" align="middle" justify="center">
              <Col className="container-item">
                <Link to={'/#'}>
                  <div
                    className="footer-contact-item footer-contact-item-address"
                    style={{ backgroundImage: `url(${Address})` }}
                  >
                    <Row className="footer-contact-item-phone-content">
                      <span className="text-address">{companyInfo?.jusho}</span>
                    </Row>
                  </div>
                </Link>
              </Col>
              <Col className="container-item container-item_email">
                <a
                  href={`mailto:${CONTACT_INFO.MAIL}`}
                  className="footer-contact-item footer-contact-item-email"
                  style={{ backgroundImage: `url(${Email})` }}
                >
                  <p className="text-mail">
                    {t('footer.contact.mail')}
                    <Typography.Text className="text-link">
                      {t('footer.contact.link')}
                    </Typography.Text>
                  </p>
                </a>
              </Col>
              <Col className="container-item">
                <Link to={'/#'}>
                  <div
                    className="footer-contact-item footer-contact-item-phone"
                    style={{ backgroundImage: `url(${Contact})` }}
                  >
                    <Row className="footer-contact-item-phone">
                      <span className="text-phone">{companyInfo?.telno}</span>
                      <span className="text-date">
                        {t('footer.contact.date')}
                        {companyInfo?.eigyouJikanFrom &&
                          companyInfo?.eigyouJikanTo && (
                            <span className="text-time">
                              {`${companyInfo?.eigyouJikanFrom} - ${companyInfo?.eigyouJikanTo}`}
                            </span>
                          )}
                      </span>
                      <span className="text-des custom-text-des">
                        {t('footer.contact.des')}
                      </span>
                    </Row>
                  </div>
                </Link>
              </Col>
            </Row>
            <div className="footer-bottom">
              <div className="footer-bottom-left"></div>
              <p className="footer-bottom-text">
                {t('footer.footer_bottom', { currentYear })}
              </p>
              <div className="footer-bottom-right"></div>
            </div>
          </div>
        </Layout>
      )}
      {!hasContact && (
        <Layout className="layout-container">
          <div className="">
            <p className="custom_footer_bottom">
              {t('footer.footer_bottom', { currentYear })}
            </p>
          </div>
        </Layout>
      )}
      <PluginQrCode />
      {queryPlugin?.data?.data?.item?.chatBot && (
        <ElfsightWidget widgetID={queryPlugin?.data?.data?.item?.chatBot} />
      )}
    </Footer>
  );
};

export default AppFooter;
